// Environment variables utility
// This helps with type safety and default values

// IMPORTANT: For static exports with token substitution:
// - Build-time: Use #{TOKEN_*}# placeholders that get baked into the bundle
// - Release-time: Replace these tokens with actual values in the release pipeline

// Log environment variables for debugging
if (typeof window !== "undefined") {
  console.log("Client-side environment variables:")
  console.log("NEXT_PUBLIC_API_URL:", process.env.NEXT_PUBLIC_API_URL)
  console.log("NEXT_PUBLIC_ADMIN_SERVICE_API_ENDPOINT:", process.env.NEXT_PUBLIC_ADMIN_SERVICE_API_ENDPOINT)
  console.log("NEXT_PUBLIC_WORKFLOW_API_URL:", process.env.NEXT_PUBLIC_WORKFLOW_API_URL)
  console.log("NEXT_PUBLIC_AUDIT_API_URL:", process.env.NEXT_PUBLIC_AUDIT_API_URL)
  console.log("NEXT_PUBLIC_FBO_REPORT_API_URL:", process.env.NEXT_PUBLIC_FBO_REPORT_API_URL)
  console.log("NEXT_PUBLIC_USE_MOCK_DATA:", process.env.NEXT_PUBLIC_USE_MOCK_DATA)
  console.log("NEXT_PUBLIC_BASE_PATH:", process.env.NEXT_PUBLIC_BASE_PATH)
  console.log("NEXT_PUBLIC_BUILD_ENV:", process.env.NEXT_PUBLIC_BUILD_ENV)
  console.log("NEXT_PUBLIC_MIXPANEL_TOKEN:", process.env.NEXT_PUBLIC_MIXPANEL_TOKEN)
  console.log("NEXT_PUBLIC_AUTOMATIONS_URL:", process.env.NEXT_PUBLIC_AUTOMATIONS_URL)
}

// Application environment variables
// These will be token placeholders at build time, replaced in release pipeline
export const env = {
  // API URL for backend services
  apiUrl: process.env.NEXT_PUBLIC_API_URL || "#{API_URL}#",

  // Admin Service API Endpoint
  adminServiceApiEndpoint: process.env.NEXT_PUBLIC_ADMIN_SERVICE_API_ENDPOINT || "#{ADMIN_SERVICE_API_ENDPOINT}#",

  // Workflow Service API Endpoint
  workflowApiUrl: process.env.NEXT_PUBLIC_WORKFLOW_API_URL || "#{WORKFLOW_SERVICE_API_ENDPOINT}#",

  // Audit Service API Endpoint
  auditApiUrl: process.env.NEXT_PUBLIC_AUDIT_API_URL || "#{AUDIT_SERVICE_API_ENDPOINT}#",

  // Whether to use mock data instead of real API calls
  useMockData: process.env.NEXT_PUBLIC_USE_MOCK_DATA || "#{USE_MOCK_DATA}#",

  // Build environment
  buildEnv: process.env.NEXT_PUBLIC_BUILD_ENV || "#{BUILD_ENV}#",

  // Base path
  basePath: process.env.NEXT_PUBLIC_BASE_PATH || "#{BASE_PATH}#",

  // Mixpanel tracking token
  mixpanelToken: process.env.NEXT_PUBLIC_MIXPANEL_TOKEN || "#{MIXPANEL_TOKEN}#",

  // Automations URL (external)
  automationsUrl: process.env.NEXT_PUBLIC_AUTOMATIONS_URL || "#{AUTOMATIONS_URL}#",

  // Messages API URL
  messagesApiUrl: process.env.NEXT_PUBLIC_MESSAGES_API_ENDPOINT || "#{MESSAGES_SERVICE_API_ENDPOINT}#",

  // FBO Report API URL
  fboReportApiUrl: process.env.NEXT_PUBLIC_FBO_REPORT_API_URL || "#{REPORTS_API_URL}#",

}

// Log the final env object for debugging
if (typeof window !== "undefined") {
  console.log("Final env object:", env)
} 